/**
 * Created by Howard on 11/12/2020.
 */
(function($) {
    $('document').ready(function () {
        let validEmail = function(email) {
            return /^\S+@\S+\.\S+$/.test(email);
        }

        if ($('.checkout-wrapper').length === 0) {
            return; // Abandon this hook if target does not exist
        }

        if ($('.woocommerce-order-pay').length === 0) {
            // Only run the following if the checkout is NOT the order-pay page
            $('#apply-coupon').click(function() {
                $('#coupon_code').val($('#visible-coupon-input').val());
                $('form.checkout_coupon').submit();
            });

            $('.store-credit-coupon').click(function() {
                let coupon = $(this).data('coupon-number');
                $('#coupon_code').val(coupon);
                $('form.checkout_coupon').submit();
            });
        }

        $('.proceed > .button').click(function() {
            var target = $(this).data('tabs-target');
            if (typeof target === 'undefined') return;

            jQuery('#checkout-tabs').foundation('selectTab', '#'+target);
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });

        $('.proceed > .complete-order').click(function() {
            let firstName = $('#billing_first_name').val();
            let lastName = $('#billing_last_name').val();
            let email = $('#billing_email').val();
            let phone = $('#billing_phone').val();

            let myInfoChecked = $('input[type="checkbox"].my-info:checked');
            myInfoChecked.each(function() {
                let cartId = $(this).data('cart-id');
                $('input[type="text"][data-cart-id="'+cartId+'"].full-name').val(firstName + ' ' + lastName);
                $('input[type="text"][data-cart-id="'+cartId+'"].email-address').val(email);
                $('input[type="text"][data-cart-id="'+cartId+'"].phone-number').val(phone);
            });
        });

        const clickMyInfo = function() {
            let cartId = $(this).data('cart-id');
            let target = $('input[type="text"][data-cart-id="'+cartId+'"]');

            let isChecked = $(this).is(':checked');

            target.val(isChecked ? cartId : '');

            if (isChecked) {
                target.hide();
                target.parent().hide();
            } else {
                target.show();
                target.parent().show();
            }
        };
        let myInfoCheckbox = $('input[type="checkbox"].my-info');
        myInfoCheckbox.each(clickMyInfo);
        myInfoCheckbox.change(clickMyInfo);

        $('#checkout-tabs').on('change.zf.tabs', function() {
            if ($('#panel3:visible').length && $('#panel3').hasClass('disabled')) {
                $('#checkout-tabs').foundation('selectTab', 'panel2');
            }

            if ($('#panel4:visible').length && $('#panel4').hasClass('disabled')) {
                $('#checkout-tabs').foundation('selectTab', 'panel3');
            }

        });

        let guestInfoInputs = $('input[type="text"].guest-info');

        const validateConfirmations = function() {
            let lodgeGuestsIcon = $('#gic-lodge-guests');
            let dayPassIcon = $('#gic-day-pass-anglers');
            let afternoonPassIcon = $('#gic-afternoon-pass-anglers');
            let seasonPassholderIcon = $('#gic-season-passholders');

            let lodgeGuestInfo = $('input.lodge-guest-info');
            let dayPassGuestInfo = $('input.day-pass-guest-info');
            let afternoonPassGuestInfo = $('input.afternoon-pass-guest-info');
            let seasonPassholderGuestInfo = $('input.season-passholder-guest-info');

            let invalidLodgeGuestInfo = false;
            lodgeGuestInfo.each(function() {
                if ($(this).val().trim() === '') {
                    invalidLodgeGuestInfo = true;
                }
            });
            let lodgeGuestEmails = $('.lodge-guest-info.email-address');
            lodgeGuestEmails.each(function() {
                let cart_id = $(this).data('cart-id');
                let ischecked = $('input[type="checkbox"][data-cart-id="'+cart_id+'"]:checked')
                if (!ischecked.length && !validEmail($(this).val().trim())) {
                    invalidLodgeGuestInfo = true;
                }
            });

            let invalidDayPassGuestInfo = false;
            dayPassGuestInfo.each(function() {
                if ($(this).val().trim() === '') {
                    invalidDayPassGuestInfo = true;
                }
            });
            let dayPassholderEmails = $('.day-pass-guest-info.email-address');
            dayPassholderEmails.each(function() {
                let cart_id = $(this).data('cart-id');
                let ischecked = $('input[type="checkbox"][data-cart-id="'+cart_id+'"]:checked')
                if (!ischecked.length && !validEmail($(this).val().trim())) {
                    invalidDayPassGuestInfo = true;
                }
            });

            let invalidAfternoonPassGuestInfo = false;
            afternoonPassGuestInfo.each(function() {
                if ($(this).val().trim() === '') {
                    invalidAfternoonPassGuestInfo = true;
                }
            });
            let afternoonPassholderEmails = $('.afternoon-pass-guest-info.email-address');
            afternoonPassholderEmails.each(function() {
                let cart_id = $(this).data('cart-id');
                let ischecked = $('input[type="checkbox"][data-cart-id="'+cart_id+'"]:checked')
                if (!ischecked.length && !validEmail($(this).val().trim())) {
                    invalidAfternoonPassGuestInfo = true;
                }
            });

            let invalidSeasonPassholderGuestInfo = false;
            seasonPassholderGuestInfo.each(function() {
                if ($(this).val().trim() === '') {
                    invalidSeasonPassholderGuestInfo = true;
                }
            });
            let seasonPassholderEmails = $('.season-passholder-guest-info.email-address');
            seasonPassholderEmails.each(function() {
                let cart_id = $(this).data('cart-id');
                let ischecked = $('input[type="checkbox"][data-cart-id="'+cart_id+'"]:checked')
                if (!ischecked.length && !validEmail($(this).val().trim())) {
                    invalidSeasonPassholderGuestInfo = true;
                }
            });

            if (invalidLodgeGuestInfo) {
                lodgeGuestsIcon.removeClass('fa-check');
                lodgeGuestsIcon.addClass('fa-ellipsis-h');
            } else {
                lodgeGuestsIcon.removeClass('fa-ellipsis-h');
                lodgeGuestsIcon.addClass('fa-check');
            }

            if (invalidDayPassGuestInfo) {
                dayPassIcon.removeClass('fa-check');
                dayPassIcon.addClass('fa-ellipsis-h');
            } else {
                dayPassIcon.removeClass('fa-ellipsis-h');
                dayPassIcon.addClass('fa-check');
            }

            if (invalidAfternoonPassGuestInfo) {
                afternoonPassIcon.removeClass('fa-check');
                afternoonPassIcon.addClass('fa-ellipsis-h');
            } else {
                afternoonPassIcon.removeClass('fa-ellipsis-h');
                afternoonPassIcon.addClass('fa-check');
            }

            if (invalidSeasonPassholderGuestInfo) {
                seasonPassholderIcon.removeClass('fa-check');
                seasonPassholderIcon.addClass('fa-ellipsis-h');
            } else {
                seasonPassholderIcon.removeClass('fa-ellipsis-h');
                seasonPassholderIcon.addClass('fa-check');
            }

            return !(invalidLodgeGuestInfo || invalidDayPassGuestInfo || invalidAfternoonPassGuestInfo || invalidSeasonPassholderGuestInfo)
        };

        const validateGuestInfo = function() {
            let confirmations = validateConfirmations();

            let submitButton = $('a.guest-info-next-button');
            let conditionsTab = $('#panel3');
            if (!confirmations) {
                submitButton.addClass('disabled');
                conditionsTab.addClass('disabled');
            } else {
                submitButton.removeClass('disabled');
                conditionsTab.removeClass('disabled');
            }
        };

        validateGuestInfo();
        myInfoCheckbox.change(validateGuestInfo);
        guestInfoInputs.keyup(validateGuestInfo);

        let policyAgreements = $('input[type="checkbox"].policy-checkbox');
        const validateAgreements = function() {
            let submitButton = $('a.conditions-next-button');
            let paymentTab = $('#panel4');
            if (policyAgreements.length === $('input[type="checkbox"].policy-checkbox:checked').length) {
                submitButton.removeClass('disabled');
                paymentTab.removeClass('disabled');
            } else {
                submitButton.addClass('disabled');
                paymentTab.addClass('disabled');
            }
        };

        validateAgreements();
        policyAgreements.change(validateAgreements);

        $('select#billing_country').change(function() {
            var countryCode = $(this).find('option:selected').val();
            var inputStates = $('input#billing_state');
            var billingStates = $('select#billing_state');

            $.ajax({
                url: wpApiSettings.root + wpApiSettings.namespace + '/country/'+countryCode+'/states',
                type: "GET",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                }
            }).done(function(r) {
                if (r.hasOwnProperty('states') && Object.keys(r.states).length > 0) {
                    if (inputStates.length !== 0) {
                        inputStates.replaceWith('<select name="billing_state" id="billing_state" class="state_select " autocomplete="address-level1" data-placeholder="Select an option…" data-input-classes=""></select>');
                        billingStates = $('select#billing_state');
                    }

                    billingStates.empty();
                    billingStates.append($("<option value>Select an option…</option>"));

                    $.each(r.states, function(k, v) {
                        billingStates.append($("<option></option>").attr("value", v).text(k))
                    });
                } else {
                    if (billingStates.length !== 0) {
                        billingStates.replaceWith('<input type="text" class="input-text " value="" placeholder="" name="billing_state" id="billing_state" autocomplete="address-level1" data-input-classes="">');
                    }
                }
            });
        });
    });

})(jQuery);